<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>Nuevo mapa</h2>
    </div>

    <div class="container-body">

        <section class="info-card form-card">
            <h3 class="info-card__title">Datos del mapa</h3>

            <div class="form-field">
                <label for="name">Nombre <span class="form-field__required" aria-hidden="true">*</span></label>
                <input id="name" v-model="map.name" type="text"
                name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required'"
                placeholder="Ingresa el nombre del mapa"/>
                <p v-if="errors.has('nombre')" class="form-field__error">{{ errors.first('nombre') }}</p>
            </div>

            <div class="form-field">
                <label for="desc">Descripción</label>
                <textarea id="desc" v-model="map.desc" :maxlength="descMaxLength" placeholder="Ingresa la descripción del mapa"></textarea>
                <p class="form-field__hint" :class="{'form-field__hint--full': descLength === descMaxLength}">
                    {{ descLength }} / {{ descMaxLength }} caracteres
                </p>
            </div>

            <div class="form-field">
                <label for="imgfile">Imagen de portada</label>
                <div class="map-image-picker">
                    <img
                        class="map-image-picker__preview"
                        :src="previewImageURL"
                        alt="Previsualización de la imagen del mapa"
                        @error="previewError = true"
                    />
                    <div class="map-image-picker__actions">
                        <p class="map-image-picker__state">
                            {{ map.imgurl ? 'Imagen propia del mapa' : 'Se está usando la imagen por defecto' }}
                        </p>

                        <!-- El input nativo se oculta: su apariencia la pone el navegador y
                             no se puede alinear con los botones del sistema. El label hace de disparador. -->
                        <input id="imgfile" class="map-image-picker__input" type="file" accept="image/jpeg,image/png,image/webp" @change="onImageSelected" />

                        <div class="map-image-picker__buttons">
                            <label for="imgfile" class="btn btn-secondary map-image-picker__trigger">
                                {{ map.imgurl ? 'Cambiar imagen' : 'Subir imagen' }}
                            </label>
                            <button v-if="map.imgurl" type="button" class="btn btn-danger" v-on:click="removeImage()">Quitar imagen</button>
                        </div>

                        <p class="form-field__hint">JPG, PNG o WEBP, idealmente en proporción 3:2 (ej. 1200×800 px). Se redimensiona sola al guardar.</p>
                    </div>
                </div>
            </div>

            <div class="form-field">
                <label>Herramientas del visor</label>
                <p class="form-field__hint">Los usuarios de este mapa solo verán las herramientas marcadas.</p>
                <ul class="tool-picker">
                    <li v-for="tool in toolCatalog" :key="tool.id" class="tool-picker__item">
                        <input type="checkbox" :id="'tool-' + tool.id" :value="tool.id"
                            v-model="map.tools" :disabled="isProtectedTool(tool.id)" />
                        <label :for="'tool-' + tool.id">
                            {{ tool.label }}
                            <span v-if="isProtectedTool(tool.id)" class="tool-picker__always">Siempre disponible</span>
                        </label>
                    </li>
                </ul>
            </div>
        </section>

        <div class="form-actions">
            <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
            <button class="btn btn-primary" v-on:click="onClickGoNext()">Crear mapa</button>
        </div>

    </div>
 
</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'

import {restMap} from '@/components/mixin/restMap.js'
import {mapImagePicker} from '@/components/mixin/mapImagePicker.js'
import { MAP_TOOLS, PROTECTED_MAP_TOOLS } from '@/components/mapControls/mapToolsCatalog.js'

export default{
    name: 'test',
    mixins: [restMap, mapImagePicker],
    components:{
        Breadcrumb
    },
    data(){
        return{
            // Mismo tope que ya aplicaba el maxlength del textarea (QA-28)
            descMaxLength: 70,
            toolCatalog: MAP_TOOLS
        }
    },
    computed: {
        descLength: function(){
            return (this.map.desc || '').length
        },
        routesBread: function(){
          return [
                {name: 'Mapas', path: '/mapas'},
                {name:'Nuevo mapa'},
          ]
        }
    },
    props: [],
    methods:{
        isProtectedTool: function(toolId) {
            return PROTECTED_MAP_TOOLS.includes(toolId)
        },
        onClickGoBack: function() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/mapas')
        },
        onClickGoNext: function() {
            const that = this;
            this.$validator.validateAll()
            .then(function (response) {
                if(response) {
                    if(that.map.imgurl !=null && !that.map.imgurl) {
                        that.map.imgurl = that.defaultImageURL
                    }
                    that.postMap();
                } else {

                }
            })
        }
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
.form-card {
    max-width: 720px;
    margin-bottom: 1rem;
}

.form-field {
    margin-bottom: 1.15rem;

    &:last-child {
        margin-bottom: 0;
    }
}

/* La etiqueta va arriba de forma explícita. Antes quedaba arriba de rebote, porque la
   regla global `input, select, textarea { width: 100% }` no dejaba espacio al lado;
   al acotar el ancho del campo se subían a la misma línea. */
/* Hijo directo a propósito: el disparador de imagen también es un <label> y con el
   selector descendente ganaría en especificidad, volviéndolo un bloque de ancho completo. */
.form-field > label {
    display: block;
    margin-bottom: 0.3rem;
}

/* Un campo de nombre de 700px de ancho no se lee mejor, sólo se ve descuidado */
.form-field input[type="text"] {
    max-width: 26rem;
}

.form-field textarea {
    max-width: 34rem;
    min-height: 4.5rem;
}

.form-field__required {
    color: var(--color-danger);
}

/* Clase propia y no .error-label: la global es position:absolute y se encima
   con el campo siguiente (el mismo problema que el login con contraseña temporal) */
.form-field__error {
    margin: 0.3rem 0 0;
    color: var(--color-danger);
    font-size: 0.78rem;
}

.form-field__hint {
    margin: 0.3rem 0 0;
    color: var(--color-ghost);
    font-size: 0.75rem;
}

.form-field__hint--full {
    color: var(--color-danger);
}

.form-actions {
    display: flex;
    gap: 0.6rem;
    max-width: 720px;
}

.map-image-picker {
    display: flex;
    align-items: stretch;
    gap: 1rem;
    flex-wrap: wrap;

    &__preview {
        width: 240px;
        height: 135px;
        object-fit: cover;
        border: 1px solid var(--color-line);
        border-radius: 8px;
        flex-shrink: 0;
        background: var(--color-mist);
    }

    &__actions {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 0.55rem;
        align-items: flex-start;
    }

    &__state {
        margin: 0;
        font-size: 0.82rem;
        font-weight: 600;
        color: var(--color-graphite);
    }

    /* Fuera del flujo pero enfocable con teclado: sigue siendo el control real */
    &__input {
        position: absolute;
        width: 1px;
        height: 1px;
        opacity: 0;
        pointer-events: none;
    }

    &__buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
    }

    /* El disparador es un <label> y "Quitar imagen" un <button>: no calculan
       igual su caja. El botón no hereda la tipografía del documento y trae su
       propio line-height, así que con textos del mismo largo salían de distinto
       ancho y alto. Se igualan los dos acá, en vez de darle medidas a mano solo
       al label —el padding queda el de .btn para ambos. */
    &__buttons .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        font-family: inherit;
        line-height: 1.4;
        margin: 0;
        cursor: pointer;
    }
}

/* El input oculto recibe foco por teclado; el borde tiene que verse en el disparador */
.map-image-picker__input:focus + .map-image-picker__buttons .map-image-picker__trigger {
    box-shadow: 0 0 0 3px rgba(59, 110, 148, 0.25);
}

.tool-picker {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.35rem 1rem;
    max-width: 34rem;
}

.tool-picker__item {
    display: flex;
    align-items: center;

    label {
        margin: 0;
        cursor: pointer;
    }

    input:disabled + label {
        cursor: default;
    }
}

.tool-picker__always {
    display: block;
    font-size: 0.75rem;
    color: var(--color-ghost);
}
</style>
